module.exports = __webpack_public_path__ + "img/czech-republic.8c881e41.svg";